import useClientState from '@/state/useClientState';

export default function useSearchStatusStore() {
  const showNoSearchResults = useClientState((state) => state.searchStatus.showNoSearchResults);
  const showNothingToShow = useClientState(
    (state) => state.searchStatus.hasPerformedSearch && state.searchStatus.showNothingToShow,
  );
  const isSearching = useClientState((state) => state.searchStatus.isSearching);
  const setShowNoSearchResults = useClientState((state) => state.setShowNoSearchResults);
  const setShowNothingToShow = useClientState((state) => state.setShowNothingToShow);
  const setIsSearching = useClientState((state) => state.setIsSearching);
  return {
    showNoSearchResults,
    showNothingToShow,
    isSearching,
    setShowNoSearchResults,
    setShowNothingToShow,
    setIsSearching,
  };
}
